import React, { useState, useEffect } from 'react';
import DashboardHeaderCard from '@/components/common/DashboardHeaderCard';
import { Truck, CheckCircle, XCircle } from 'lucide-react';
import vehicleService from '@/services/vehicleService';

const VehiclesManagementHeader = ({ vehicles }) => {
  const [stats, setStats] = useState({
    totalVehicles: 0,
    activeVehicles: 0,
    inactiveVehicles: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVehicleStats = async () => {
      try {
        setLoading(true);
        const statsData = await vehicleService.getDashboardStatistics();
        setStats({
          totalVehicles: statsData.total_vehicles || 0,
          activeVehicles: statsData.active_vehicles || 0,
          inactiveVehicles: statsData.inactive_vehicles || 0
        });
      } catch (error) {
        console.error("Failed to fetch dashboard statistics:", error);
        try {
          const allVehiclesData = await vehicleService.getAllVehicles();
          let allVehicles = [];
          if (allVehiclesData && typeof allVehiclesData === 'object' && Array.isArray(allVehiclesData.data)) {
            allVehicles = allVehiclesData.data;
          } else if (Array.isArray(allVehiclesData)) {
            allVehicles = allVehiclesData;
          } else if (allVehiclesData && typeof allVehiclesData === 'object' && Array.isArray(allVehiclesData.vehicles)) {
            allVehicles = allVehiclesData.vehicles;
          }
          const totalVehicles = allVehicles.length;
          const activeVehicles = allVehicles.filter(vehicle => vehicle.is_active).length;
          const inactiveVehicles = totalVehicles - activeVehicles;
          setStats({
            totalVehicles,
            activeVehicles,
            inactiveVehicles
          });
        } catch (fallbackError) {
          console.error("Fallback method also failed:", fallbackError);
          const totalVehicles = vehicles.length;
          const activeVehicles = vehicles.filter(vehicle => vehicle.status === 'Active').length;
          const inactiveVehicles = totalVehicles - activeVehicles;
          setStats({
            totalVehicles,
            activeVehicles,
            inactiveVehicles
          });
        }
      } finally {
        setLoading(false);
      }
    };

    fetchVehicleStats();
  }, []);

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <DashboardHeaderCard
          name="Total Vehicles"
          count="0"
          icon={<Truck className="h-6 w-6 text-primary" />}
        />

        <DashboardHeaderCard
          name="Active Vehicles"
          count="0"
          icon={<CheckCircle className="h-6 w-6 text-primary"/>}
        />

        <DashboardHeaderCard
          name="Inactive Vehicles"
          count="0"
          icon={<XCircle className="h-6 w-6 text-primary" />}
        />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <DashboardHeaderCard
        name="Total Vehicles"
        count={stats.totalVehicles.toString()}
        icon={<Truck className="h-6 w-6 text-primary" />}
      />

      <DashboardHeaderCard
        name="Active Vehicles"
        count={stats.activeVehicles.toString()}
        icon={<CheckCircle className="h-6 w-6 text-primary"/>}
      />

      <DashboardHeaderCard
        name="Inactive Vehicles"
        count={stats.inactiveVehicles.toString()}
        icon={<XCircle className="h-6 w-6 text-primary" />}
      />
    </div>
  );
};

export default VehiclesManagementHeader;